import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SmartFrameSwitcher, SmartFrame } from 'bricks/SmartFrameSwitcher';
import ArticleCard from 'bricks/ArticleCard';

import PopularArticleHeading from './components/PopularArticleHeading';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

function PopularArticlesLayout({ articles, isMobile, framesPerSlide, tags }) {
  const { headlineTagArticle, ...headlineTags } = tags;
  return articles.length !== 0 ?
      <div id="interesting-articles" className={cx('wrapper', isMobile ? 'componentMobile' : '')}>
        <PopularArticleHeading {...headlineTags} />
        <div className={cx('list')}>
          <SmartFrameSwitcher
            framesPerSlide={framesPerSlide}
            arrowClass={cx('overriddenArrow')}
            draggable={isMobile}
            noSwitch={!isMobile}
            noArrows
            className={cx(isMobile && 'switcher')}
          >
            {articles.map(({ description, imageUrl, title, url }, index) => (
              <SmartFrame key={+index} className={cx(!isMobile && 'frameArticle')}>
                <ArticleCard
                  className={cx('article')}
                  image={imageUrl}
                  href={url}
                  title={title}
                  description={description}
                  isMobile={isMobile}
                  key={+index}
                  {...headlineTagArticle}
                />
              </SmartFrame>
            ))}
          </SmartFrameSwitcher>
        </div>
      </div>
    : null;
}

PopularArticlesLayout.defaultProps = {
  articles: [],
};

PopularArticlesLayout.propTypes = {
  isMobile: PropTypes.bool,
  framesPerSlide: PropTypes.number,
  articles: PropTypes.array,
  tags: PropTypes.shape({
    headline: PropTypes.string,
    headlineTagName: PropTypes.string,
    headlineTagArticle: PropTypes.string,
  }),
};

export default PopularArticlesLayout;
